export default __webpack_public_path__ + "static/media/41_mobile.fd97d4ee.jpg";